import React from 'react';

const PortfolioComparisonImage = ({ alt = "Dashboard showing side-by-side portfolio comparison with value metrics" }) => {
  return (
    <div className="relative w-full mb-8">
      <div className="relative group">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-2xl blur-3xl"></div>
        <div className="relative bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-4">
          <img
            src="/images/portfolio-comparison.png"
            alt={alt}
            className="w-full h-auto rounded-lg"
            onError={(e) => {
              // Fallback if image doesn't exist yet
              e.target.style.display = 'none';
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PortfolioComparisonImage;

